import API from '../plugins/axiosInstagram';

export const getAllPosts = () => {
  return new Promise((resolve, reject) => {
    API.get(
      `${process.env.REACT_APP_INSTAGRAM_USER_ID}/media?access_token=${process.env.REACT_APP_INSTAGRAM_TOKEN}`
    )
      .then((resp) => {
        resolve(resp.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const handleCarouselPost = (post) => {
  return new Promise((resolve, reject) => {
    API.get(
      `https://graph.instagram.com/${post.id}/children?access_token=${process.env.REACT_APP_INSTAGRAM_TOKEN}&fields=media_url,media_type`
    )
      .then((resp) => {
        const firstChild = resp.data.data[0];

        resolve({
          ...post,
          media_url: firstChild.media_url,
          media_type: firstChild.media_type
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSinglePost = (postId) => {
  return new Promise((resolve, reject) => {
    API.get(
      `https://graph.instagram.com/${postId}?access_token=${process.env.REACT_APP_INSTAGRAM_TOKEN}&fields=media_url,permalink,media_type`
    )
      .then((resp) => {
        const post = resp.data;

        if (post.media_type === 'CAROUSEL_ALBUM') {
          handleCarouselPost(post)
            .then(resolve)
            .catch(() => {
              resolve(post);
            });
        } else {
          resolve(post);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
